import { IconButton as MuiIconButton } from '@mui/material'
import styled from 'styled-components'
import UnstyledThumbWithGallery from '../../../components/ThumbWithGallery'
import { BREAKPOINT_SM } from '../../../theme/ota'

interface ContainerProps {
  isCartView?: boolean
}

interface InfoProps {
  isMainInfo?: boolean
  highlight?: boolean
}

type InfoWeight = 600 | 500 | 400

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: ${({ isCartView }) => (isCartView ? '10px' : '0 20px')};
  border: ${({ isCartView }) => isCartView && '1px solid #e6e6e6'};
  border-radius: ${({ isCartView }) => isCartView && '4px'};

  @media (max-width: calc(${BREAKPOINT_SM})) {
    padding: ${({ isCartView }) => (isCartView ? '10px' : '0px')};
    gap: 0px;
  }
`

export const HeaderContainer = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: ${({ isCartView }) => (isCartView ? 'row' : 'column')};

  @media (max-width: calc(${BREAKPOINT_SM})) {
    gap: 0px;
  }
`

export const TitleContainer = styled.div<ContainerProps>`
  @media (max-width: calc(${BREAKPOINT_SM})) {
    padding: ${({ isCartView }) => (isCartView ? '0px' : '15px')};
  }
`

export const BodyAddonItem = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: ${({ isCartView }) => (!isCartView ? '10px' : '0')};
  border: ${({ isCartView }) => !isCartView && '1px solid #e6e6e6'};
  border-radius: ${({ isCartView }) => !isCartView && '4px'};
`

export const BodyContainer = styled.div<ContainerProps>`
  @media (max-width: calc(${BREAKPOINT_SM})) {
    padding: ${({ isCartView }) => (isCartView ? '0px' : '0px 15px 15px 15px')};
  }
`

export const InfoContainer = styled.div<{ spaceItems?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: ${({ spaceItems }) => (spaceItems ? 'space-between' : 'flex-start')};
`

export const AddonThumbnail = styled.img<ContainerProps>`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
`

export const AddonTitle = styled.p<InfoProps>`
  padding: 0;
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #273240;

  &.mb-5 {
    margin-bottom: 5px;
  }
`

export const AddonSubTitle = styled.p`
  padding: 0;
  margin: 0;
  max-width: 150px;
  font-size: 11px;
  font-weight: 400;
  color: #9c9c9c;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const AddonInfo = styled.span<{ weight?: InfoWeight }>`
  font-size: 13px;
  font-weight: ${({ weight }) => (weight ? weight : 400)};
  color: #273240;
`

export const AddonSubInfo = styled.span<{ light?: boolean }>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ light }) => (light ? '#9c9c9c' : '#273240')};
`

export const AddonPrice = styled.span`
  align-self: end;
  font-size: 12px;
  font-weight: 700;
  color: #273240;
`

export const IconButton = styled(MuiIconButton)`
  padding: 0 !important;
  width: 24px;
  height: 24px !important;
`

export const ThumbWithGallery = styled(UnstyledThumbWithGallery)`
  height: 100px;

  .button-gallery {
    margin-right: 20px;
  }

  @media (max-width: calc(${BREAKPOINT_SM})) {
    height: 180px;

    .swiper-container {
      border-radius: 0px;
    }
  }
`
